var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dataCallout card static"},[_c('div',{staticClass:"card-content has-text-centered is-width-100"},[_c('p',{staticClass:"title is-5"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('p',[_c('b',{staticClass:"is-size-1"},[_vm._v(_vm._s(_vm.used))]),_vm._v(" "),_c('span',{staticClass:"is-size-5"},[_vm._v("/ "+_vm._s(_vm.limit))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }